const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop-intelligence/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
export const loopIntelligenceBeforeLoad = requirePermission('view_recommendations');
export const Route = createFileRoute('/(app)/org/$org/loop-intelligence')({
  beforeLoad: loopIntelligenceBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loopIntelligence.nav)
    }
  }
});